import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchAccounts, sendTimekeepingData} from '../actions/stamp'
import Stamp from '../components/Stamp';

const mapStateToProps = state => {
  const { account } = state
  const {
    isFetching,
    lastUpdated,
    totalRows,
    timekeepingData,
  } = account || {
    isFetching: true,
    items: [],
    deletedId: -1,
    timekeepingData: null
  }

  return {
    items: account.items,
    isFetching,
    lastUpdated,
    totalRows,
    timekeepingData,
    time_zone: state.account.time_zone,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserAccount: fetchAccounts,
      sendTimekeeping: sendTimekeepingData,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Stamp)

// const mapStateToProps = state => {
//   // ... các state khác
//   return {
//     timeZone: state.time_zone
//     // ... các state khác
//   };
// };

// const mapDispatchToProps = dispatch => {
//   return {
//     // ... các actions khác
//     fetchTimeZone: () => dispatch(fetchTimeZone())
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(Stamp)
